(ns common.entity-ownership)

(defn ->id-or-nil
  [arg]
  (or (:db/id arg)
      (when (integer? arg)
        arg)))

(def entity-type-owner-attributes
  {:entity.type/oppo               :oppo/owner
   :entity.type/person             :person/contact-owner
   :entity.type/company            :company/company-owner
   :entity.type/investor           :investor/owner
   :entity.type/kyc-profile        :kyc-profile/our-kyc-contact
   :entity.type/tenant-kyc-profile :tenant-kyc-profile/our-kyc-contact
   :entity.type/contract-kyc-profile :contract-kyc-profile/our-kyc-contact
   :entity.type/fund-commitment    :fund-commitment/owner
   :entity.type/fundraising-opportunity :fundraising-opportunity/owner
   :entity.type/sales-opportunity  :sales-opportunity/owner
   :entity.type/sale-agreement     :sale-agreement/owner
   :entity.type/exit-opportunity   :exit-opportunity/owner
   :entity.type/holding            :holding/owner
   :entity.type/kpi-member         :common/owner
   :entity.type/kpi-report         :common/owner
   :entity.type/webentry           :webentry/handler-account
   :entity.type/named-view         :named-view/account
   :entity.type/graph-config       :common/owner
   :entity.type/view               :common/owner
   :entity.type/card               :common/owner
   :entity.type/ribbon             :common/owner
   :entity.type/tab                :common/owner})

(def owner-attributes
  (->> entity-type-owner-attributes
       (vals)
       (set)))

(defn entity-owner-attribute
  [entity]
  (some->> entity
           :entity/type
           (entity-type-owner-attributes)))

(defn entity-owner-id
  [entity]
  (some->> entity
           (entity-owner-attribute)
           (get entity)
           (->id-or-nil)))

(defn entity-owner?
  [account entity]
  (when-let [account-id (->id-or-nil account)]
    (= account-id (entity-owner-id entity))))
